module.exports = __webpack_public_path__ + "static/2009-money-trees-d8cacd7abecf2f4136fb4a9cbe17e4bb.jpg";